export default {
    yearsStdLiving : 3,
    funeralCost : 15000,
    childcareWeekly : 135.06,
    schoolAnnualPrivate : 354186,
    schoolAnnualGovernment : 81496.56
}